import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useSession } from '@cordata/buffet';
import { Accordian } from '~/components';
import usePatient from '~/utils/patient/hook';
import { IdentityPageProvider } from '~/utils/identity/page';
import { hasFullPatientIdentityAccess, hasLegalStatus } from '~/utils/patient/identity-access';

import IdentitySurgeries from '../identity-surgeries';
import FosterCareClinicVisits from './foster-care-clinic-visits';
import OutpatientVisits from './outpatient-visits';
import TherapyVisits from './therapy-visits';
import ERAndUrgentCareVisits from './emergency-dept-&-urgentCare';
import Hospitalizations from './hospitalizations';

const CompletedVisits = () => {
  const [, patient, actions] = usePatient();
  const { current } = useSession();

  const pageSpec = {
    title: 'Completed Visits',
    enableFullPrint: hasLegalStatus(patient),
    enableIndividualPrint: hasLegalStatus(patient),
    panels: [{
      title: 'Foster Care Clinic Visits',
      body: <FosterCareClinicVisits />,
    }, {
      title: 'Outpatient Visits',
      body: <OutpatientVisits />,
    }, {
      title: 'Physical Therapy (PT) / Occupational Therapy (OT) / Speech Pathology (SP) Visits',
      body: <TherapyVisits />,
    }, {
      title: 'Emergency Department and Urgent Care',
      body: <ERAndUrgentCareVisits />,
    }, {
      title: 'Hospitalizations',
      body: <Hospitalizations />,
    }, {
      title: 'Surgeries',
      body: <IdentitySurgeries includeFilters />,
    }],
  };

  useEffect(() => {
    actions.audit('CompletedVisits');
  }, []);

  if (!hasFullPatientIdentityAccess(patient, current?.attributes?.accessibleDivisions)) {
    return <Redirect to={`/patients/${patient.id}`} />;
  }

  return (
    <>
      <IdentityPageProvider pageSpec={pageSpec}>
        {({
          accordianItems,
          allPanelsOpen,
          expandPanel,
          openPanel,
        }) => (
          <Accordian
            openPanel={openPanel}
            allOpen={allPanelsOpen}
            setOpenPanel={expandPanel}
            items={accordianItems}
          />
        )}
      </IdentityPageProvider>
    </>
  );
};

export default CompletedVisits;
